<template>
    <div class="form-inline">
        <b-input-group>
            <b-form-select
                v-model="selectedType"
                :options="eotypes"
                :disabled="!editAllowed"
                @change="set_inputType"
            >
                <template #first>
                    <b-form-select-option value=""
                        >--
                        {{ $t('com_selecteer', { ns: 'common' }) }}
                        --</b-form-select-option
                    >
                </template>
            </b-form-select>
            <div v-if="batchrelated" class="form-inline">
                <b-input-group v-if="!useTimeInput">
                    <b-form-datepicker
                        :date-format-options="{
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit'
                        }"
                        v-model="datum"
                        @input="set_inputDate"
                        :disabled="!editAllowed"
                    ></b-form-datepicker>
                </b-input-group>
                <b-input-group v-if="useTimeInput">
                    <b-form-input
                        v-model="datum"
                        :type="'date'"
                        @blur="set_inputDate"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
                <b-form-select
                    v-model="meetplekIDBatch"
                    :options="cheeseRelatedLijst"
                    :disabled="!editAllowed"
                    @change="set_input"
                >
                    <template #first>
                        <b-form-select-option value="-1"
                            >--
                            {{ $t('com_selecteer', { ns: 'common' }) }}
                            --</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </div>
            <div v-if="productrelated" class="form-inline">
                <ingredient-selector
                    v-model="newIngredientID"
                    @input="set_itemStockLijst"
                    :editAllowed="editAllowed"
                />
                <b-form-select
                    v-model="meetplekIDItemStock"
                    :options="flexListIG"
                    :disabled="!editAllowed"
                    @change="set_input"
                >
                    <template #first>
                        <b-form-select-option value="-1"
                            >--
                            {{ $t('com_selecteer', { ns: 'common' }) }}
                            --</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </div>
            <div v-if="eorelated">
                <lookup-combo
                    key="rerenderkey"
                    v-model="meetplekID"
                    v-bind:combotype="lctypeEO"
                    v-bind:discrim="theDiscrim"
                    v-bind:forcerefresh="forcerefresh"
                    @change="set_input"
                    :disabled="!editAllowed"
                ></lookup-combo>
            </div>
        </b-input-group>
    </div>
</template>
<script>
import LookupCombo from './LookupCombo.vue';
import IngredientSelector from '../recipe/IngredientSelector.vue';
import DateHelper from '../../models/DateHelper';
import { EntityObject } from '../../models/Anayltics';
import { loadList, loadItem } from './utils';
import { Feature } from '../../models/Features';
export default {
    name: 'EntityObjectSelector',
    data: function () {
        return {
            eotypes: [
                {
                    value: window.constants.ADATA_BATCH,
                    text: this.$t('prod_bak', { ns: 'production' })
                },
                {
                    value: window.constants.ADATA_BATCHGROUP,
                    text: this.$t('prod_bakgroep', { ns: 'production' })
                },
                {
                    value: window.constants.ADATA_ITEMSTOCK_IG,
                    text:
                        this.$t('prod_stockitem', { ns: 'production' }) +
                        ': ' +
                        this.$t('prod_ingredient', { ns: 'production' })
                },
                {
                    value: window.constants.ADATA_STOCKLOCATION,
                    text: this.$t('com_location', { ns: 'common' })
                },
                {
                    value: window.constants.ADATA_EQUIPMENT,
                    text: this.$t('prod_apparaat', { ns: 'production' })
                }
            ],
            selectedType: window.constants.ADATA_BATCH,
            lctypeEO: window.constants.LCA_ENTITYOBJECT,
            flexList: [],
            flexListIG: [],
            aangeraakt: 1,
            rerenderkey: 1,
            startEntityObjectID: -1,
            meetplekIDBatch: null,
            meetplekIDItemStock: null,
            meetplekID: null,
            newIngredientID: -1,
            batchrelated: false,
            productrelated: false,
            eorelated: false,
            forcerefresh: true
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            type: Number,
            default: -1
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        editAllowed: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        selected(newVal) {
            if (newVal == undefined || newVal == -1) {
                return;
            }
            this.setSelected(newVal);
        }
    },
    components: {
        IngredientSelector,
        LookupCombo
    },
    computed: {
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        cheeseRelatedLijst() {
            // eslint-disable-next-line no-unused-vars
            const tel = this.aangeraakt;
            return this.flexList;
        },
        theDiscrim() {
            return this.selectedType;
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_input() {
            this.$nextTick(async () => {
                let id = -1;
                let eo_id = -1;
                if (this.batchrelated) {
                    id = this.meetplekIDBatch;
                    eo_id = this.meetplekIDBatch;
                } else if (this.productrelated) {
                    id = this.meetplekIDItemStock;
                } else {
                    eo_id = this.meetplekID;
                    id = this.meetplekID;
                }
                const result = new EntityObject({
                    eo_id: eo_id
                });
                result.typenaambasis = this.selectedType;
                result.veldid = id;
                if (id > 0) {
                    this.$emit('change', true);
                    this.$emit('eobject', result);
                }
            });
        },
        async set_itemStockLijst(val) {
            if (val) {
                const templijst = await loadList(
                    'product/getStockItemLijst',
                    'product/loadStockByProduct',
                    { productid: val },
                    this.forcerefresh,
                    this.$t
                );
                this.flexListIG = templijst.map((x) => ({
                    value: x.id,
                    text: x.batchID + ': (' + x.locatie + ')',
                    item: x
                }));
            } else {
                this.flexListIG = [];
            }
        },
        async set_inputDate(datum) {
            if (datum.type == "blur") {
                datum = this.datum;
            }
            const UTCdate = DateHelper.localDateToUTC(datum);
            const templijst = await loadItem(
                'analytics/loadEntityObjectForCheese',
                { productiondate: UTCdate },
                this.$t
            );
            const filteredLijst = templijst
                ? templijst.filter((x) => x.typenaambasis == this.selectedType)
                : [];
            this.flexList = filteredLijst.map((x) => ({
                value: x.id,
                text: x.naam,
                item: x
            }));
            this.aangeraakt += 1;
        },
        set_inputType(selectedType) {
            this.batchrelated = false;
            this.productrelated = false;
            this.eorelated = false;
            switch (selectedType) {
                case window.constants.ADATA_BATCHGROUP:
                case window.constants.ADATA_BATCH: {
                    this.batchrelated = true;
                    this.set_inputDate(this.datum);
                    break;
                }
                case window.constants.ADATA_ITEMSTOCK_IG: {
                    this.productrelated = true;
                    break;
                }
                default: {
                    this.eorelated = true;
                    break;
                }
            }
            this.rerenderkey += 1;
        },
        addCustomTypesToList(lijst) {
            for (let i = 0; i < lijst.length; i++) {
                const str = lijst[i];
                const obj = { value: str, text: str };
                this.eotypes.push(obj);
            }
        },
        async setSelected(val) {
            if (val == undefined || val == -1) {
                return;
            }
            const isObject = typeof val === 'object';
            this.startEntityObjectID = isObject ? val.id : val;
            const startObject = await loadItem(
                'analytics/loadEntityObject',
                { entityObjectID: this.startEntityObjectID },
                this.$t
            );
            this.selectedType = startObject.typenaambasis;
            this.datum = DateHelper.convertedToDateStringFromUTC(
                startObject.referentieDatum
            );
            const isCheese =
                this.selectedType == window.constants.ADATA_BATCHGROUP ||
                this.selectedType == window.constants.ADATA_BATCH;
            const isProduct =
                this.selectedType == window.constants.ADATA_ITEMSTOCK_IG;
            if (isCheese) {
                this.batchrelated = true;
                this.productrelated = false;
                this.eorelated = false;
                this.meetplekIDBatch = this.startEntityObjectID;
                this.set_inputDate(this.datum);
            } else if (isProduct) {
                this.meetplekIDItemStock = this.startEntityObjectID;
                if (this.flexListIG.length == 0) {
                    // duur
                    const itemstock = await loadItem(
                        'stock/loadStockItem',
                        { stockitemid: startObject.veldid },
                        this.$t
                    );
                    this.newIngredientID = itemstock.productID;
                    await this.set_itemStockLijst(itemstock.productID);
                    this.meetplekIDItemStock = itemstock.id;
                }
                this.batchrelated = false;
                this.productrelated = true;
                this.eorelated = false;
            } else {
                this.batchrelated = false;
                this.productrelated = false;
                this.eorelated = true;
                this.meetplekID = this.startEntityObjectID;
            }
        }
    },
    mounted() {
        if (this.selected > -1) {
            this.setSelected(this.selected);
        } else {
            this.startEntityObjectID = -1;
            const tijd = DateHelper.MakeDateTime(new Date());
            this.datum = DateHelper.convertedToDateStringFromUTC(tijd);
        }
        this.set_inputType(this.selectedType);
    },
    async created() {
        const tijd = DateHelper.MakeDateTime(new Date());
        this.datum = DateHelper.convertedToDateStringFromUTC(tijd);
        const lijst = await loadList(
            'analytics/getEOTypeNamesLijst',
            'analytics/loadUserDefinedTypeNames',
            null,
            this.forcerefresh,
            this.$t
        );
        this.addCustomTypesToList(lijst);
    }
};
</script>

<style scoped></style>

